<template>
    <IndexModelLayout
        :modelNamePlural="__('admin::vacations.vacation_requests')"
    >

        <Table
            :headings="[
                __('admin::labels.user'),
                __('admin::labels.period'),
                __('admin::labels.comment'),
                __('admin::labels.deputy_user'),
                __('admin::labels.texts'),
                __('admin::labels.details'),
            ]"
            :withFilters="false"
        >

            <template #results>
                <tr v-for="vacation in vacations" :key="vacation.id">
                    <td><strong>{{ vacation.user.name }}</strong></td>
                    <td>{{ $date(vacation.starts_at) }} - {{ $date(vacation.ends_at) }}</td>
                    <td>{{ vacation.comment || '—' }}</td>
                    <td>{{ vacation.deputy_user?.name || '—' }}</td>
                    <td>{{ vacation.use_default_messages ? __('admin::labels.default_messages') : __('admin::labels.custom_messages') }}</td>
                    <td>
                        <InertiaLink
                            :href="$route('admin::users.vacations.edit', { user: vacation.user_id, vacation: vacation.id })"
                            class="flex items-center gap-1 text-primary"
                        >
                            {{ __('admin::labels.view') }}
                            <ExternalLinkIcon class="w-4 h-4" />
                        </InertiaLink>
                    </td>
                    <td>
                        <div class="flex gap-0.5">
                            <button
                                class="flex justify-center items-center gap-1 w-16 rounded-l-md py-2 bg-red-400 hover:bg-red-500 transition-all duration-100 text-white"
                                @click="reject(vacation)"
                                v-tooltip="__('admin::labels.vacation_request_reject_tooltip')"
                            >
                                <XIcon class="w-5 h-5" />
                            </button>
                            <button
                                class="flex justify-center items-center gap-1 w-16 py-2 bg-green-400 hover:bg-green-500 transition-all duration-100 text-white"
                                @click="approve(vacation)"
                                v-tooltip="__('admin::labels.vacation_request_approve_tooltip')"
                            >
                                <CheckIcon class="w-5 h-5" />
                            </button>
                            <button
                                class="flex justify-center items-center gap-1 w-16 rounded-r-md py-2 bg-green-400 hover:bg-green-500 transition-all duration-100 text-white"
                                @click="approve(vacation, true)"
                                v-tooltip="__('admin::labels.vacation_request_approve_plus_salary_tooltip')"
                            >
                                <CheckIcon class="w-5 h-5" />
                                <img src="/media/salary-icon.webp" class="w-5 h-5" alt="Salary" />
                            </button>
                        </div>
                    </td>
                </tr>
            </template>

        </Table>

    </IndexModelLayout>
</template>

<script>
import {ExternalLinkIcon} from "@heroicons/vue/outline";
import {CheckIcon, XIcon} from "@heroicons/vue/solid";
import axios from "axios";
import { VTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

export default {
    components: {
        ExternalLinkIcon,
        XIcon,
        CheckIcon,
    },
    directives: {
        tooltip: VTooltip,
    },
    props: {
        vacations: Object,
    },
    methods: {
        reject(vacation) {
            axios
                .post(this.$route('admin::vacation-requests.reject', { vacation: vacation.id }))
                .then((res) => {
                    const index = this.vacations.findIndex((x) => x.id === vacation.id);
                    this.vacations.splice(index, 1);
                });
        },
        approve(vacation, syncWithSalary = false) {
            axios
                .post(this.$route('admin::vacation-requests.approve', { vacation: vacation.id, sync_with_salary: syncWithSalary }))
                .then((res) => {
                    const index = this.vacations.findIndex((x) => x.id === vacation.id);
                    this.vacations.splice(index, 1);
                });
        },
    }
}
</script>
